import React, { useCallback, useEffect, useState } from "react";
import { baseURL, secretKey } from "../../util/config";
import { PageHead, img, when } from "./kit";

// Yuz dogrulama: selfie ile profil fotografini yan yana gor, uc kutuyu isaretle. Kisi + foto = mavi tik.
const hdr = () => ({ key: secretKey, Authorization: sessionStorage.getItem("token") || "" });
const req = async (path, body) => {
  const r = await fetch(`${baseURL}faceVerify/${path}`, {
    method: body ? "POST" : "GET",
    headers: { ...hdr(), ...(body ? { "Content-Type": "application/json" } : {}) },
    body: body ? JSON.stringify(body) : undefined,
  });
  try {
    return await r.json();
  } catch (e) {
    return { status: false, message: "Sunucudan geçersiz yanıt." };
  }
};

const Kart = ({ x, onDone }) => {
  const [v, setV] = useState({ person: x.checks?.manual ? false : !!x.checks?.blink && !!x.checks?.turn, photo: true, gender: true });
  const [busy, setBusy] = useState(false);
  const u = x.user || {};
  const gonder = async (onay) => {
    let reason = "";
    if (!onay) {
      reason = window.prompt("Red sebebi (kullanıcı görür):", "Selfie profil fotoğrafıyla eşleşmedi");
      if (reason === null) return;
    }
    setBusy(true);
    const r = await req(`admin/${x._id}/review`, onay ? v : { person: false, photo: false, gender: false, reason });
    setBusy(false);
    if (!r?.status) return window.alert(r?.message || "Olmadı");
    onDone();
  };
  const kutu = (k, ad) => (
    <label style={{ display: "flex", gap: 6, alignItems: "center", fontSize: 13, margin: 0 }}>
      <input type="checkbox" checked={v[k]} onChange={(e) => setV({ ...v, [k]: e.target.checked })} /> {ad}
    </label>
  );
  return (
    <div className="card" style={{ margin: 0 }}>
      <div className="card-body" style={{ padding: 12 }}>
        <div style={{ fontWeight: 700 }}>
          {u.name || "—"} <span style={{ color: "#6B7280", fontWeight: 400 }}>ID {u.uniqueID} · {u.gender === "female" ? "Kadın" : u.gender === "male" ? "Erkek" : "?"}</span>
        </div>
        <div style={{ fontSize: 11, color: "#6B7280", marginBottom: 8 }}>
          {when(x.createdAt)} · {x.checks?.manual ? <b style={{ color: "#e67e22" }}>Android · istenen hareket: {x.checks.pose}</b> : <>göz kırpma {x.checks?.blink ? "✓" : "✗"} · baş çevirme {x.checks?.turn ? "✓" : "✗"}</>}
        </div>
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 8 }}>
          <div style={{ textAlign: "center", fontSize: 11, color: "#6B7280" }}>
            <img src={img(u.image)} alt="" style={{ width: "100%", aspectRatio: "3/4", objectFit: "cover", borderRadius: 10, background: "#eee" }} />
            Profil fotoğrafı
          </div>
          <div style={{ textAlign: "center", fontSize: 11, color: "#6B7280" }}>
            <a href={img(x.selfie)} target="_blank" rel="noreferrer">
              <img src={img(x.selfie)} alt="" style={{ width: "100%", aspectRatio: "3/4", objectFit: "cover", borderRadius: 10, background: "#eee" }} />
            </a>
            Canlı selfie
          </div>
        </div>
        {x.status === "pending" ? (
          <>
            <div className="d-flex flex-wrap" style={{ gap: 12, margin: "10px 0" }}>
              {kutu("person", "Gerçek kişi")}
              {kutu("photo", "Profil fotoğrafı aynı kişi")}
              {kutu("gender", "Cinsiyet doğru")}
            </div>
            <div className="d-flex" style={{ gap: 8 }}>
              <button className="btn btn-primary btn-sm" disabled={busy} onClick={() => gonder(true)} style={{ flex: 1 }}>
                Onayla {v.person && v.photo ? "· mavi tik" : ""}
              </button>
              <button className="btn btn-outline-danger btn-sm" disabled={busy} onClick={() => gonder(false)}>
                Reddet
              </button>
            </div>
          </>
        ) : (
          <div style={{ fontSize: 12, marginTop: 8, color: x.status === "approved" ? "#16A34A" : "#DC2626" }}>
            {x.status === "approved" ? "Onaylandı" : `Reddedildi: ${x.reason}`} {x.reviewedBy ? `· ${x.reviewedBy}` : ""}
          </div>
        )}
      </div>
    </div>
  );
};

const FaceVerify = () => {
  const [tab, setTab] = useState("pending");
  const [d, setD] = useState(null);
  const [id, setId] = useState("");
  const load = useCallback(async () => {
    const r = await req(`admin/list?status=${tab}`);
    if (r?.status) setD(r);
  }, [tab]);
  useEffect(() => {
    load();
  }, [load]);
  const elle = async (verified) => {
    if (!id.trim()) return;
    const r = await req("admin/set", { id: id.trim(), verified });
    window.alert(r?.status ? `${r.name}: mavi tik ${verified ? "verildi" : "kaldırıldı"}` : r?.message || "Olmadı");
  };
  return (
    <>
      <PageHead title="Yüz Doğrulama" sub="Canlılık kontrollü selfie ile profil fotoğrafını karşılaştır. Gerçek kişi + profil fotoğrafı onaylanınca profilde mavi tik çıkar." />
      <div className="d-flex align-items-center" style={{ gap: 8, marginBottom: 12, flexWrap: "wrap" }}>
        {[
          ["pending", `Bekleyen${d?.pending ? ` (${d.pending})` : ""}`],
          ["approved", "Onaylanan"],
          ["rejected", "Reddedilen"],
        ].map(([k, l]) => (
          <button key={k} className={`btn btn-sm ${tab === k ? "btn-primary" : "btn-outline-secondary"}`} onClick={() => setTab(k)}>
            {l}
          </button>
        ))}
        <span style={{ marginLeft: "auto", fontSize: 13 }}>Elle:</span>
        <input style={{ padding: "5px 8px", border: "1px solid #E5E7EB", borderRadius: 8, width: 130 }} placeholder="Kullanıcı ID" value={id} onChange={(e) => setId(e.target.value)} />
        <button className="btn btn-outline-primary btn-sm" onClick={() => elle(true)}>
          Tik ver
        </button>
        <button className="btn btn-outline-danger btn-sm" onClick={() => elle(false)}>
          Tik kaldır
        </button>
      </div>
      {!d ? (
        <div className="badu-empty">Yükleniyor…</div>
      ) : d.list.length === 0 ? (
        <div className="badu-empty">Kayıt yok.</div>
      ) : (
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(300px, 1fr))", gap: 12 }}>
          {d.list.map((x) => (
            <Kart key={x._id} x={x} onDone={load} />
          ))}
        </div>
      )}
    </>
  );
};

export default FaceVerify;
